
import { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Typography, Stack, MenuItem } from '@mui/material';
// routes
import { PATH_APP, PATH_AUTH } from '../routes/paths';
// hooks
import useAuth from '../hooks/useAuth';
import useIsMountedRef from '../hooks/useIsMountedRef';
// components
import MenuPopover from '../menu-popover';
import { IconButtonAnimate } from '../components/animate';
import UserIcon from "../assets/user-icon";

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'پروفایل',
    linkTo: PATH_APP.profile,
  },
];

// ----------------------------------------------------------------------

export default function AccountDropdown({user}) {
  const navigate = useNavigate();

  const { logout } = useAuth();

  const isMountedRef = useIsMountedRef();

  const [open, setOpen] = useState(null);
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };
  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate(PATH_AUTH.login, { replace: true });
      localStorage.clear()
      if (isMountedRef.current) {
        handleClose();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          padding:"12px",
          marginLeft:"20px",
          marginBottom:"4px",
          marginTop:"4px",
          background:"#fff",
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <UserIcon color="#000" width="26" height="26"/>
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          background:"#2d3039",
        borderRadius: "0 10px 10px 10px",
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 2,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap sx={{fontFamily:"YekanBakh !important" , color:"#fff"}}>
            {user?.full_name}
          </Typography>
          <Typography variant="body2" sx={{fontFamily:"YekanBakh !important" , color:"#fff"}} noWrap>
            {user.user?.mobile || user?.mobile}
          </Typography>
        </Box>

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} to={option.linkTo} component={RouterLink} sx={{fontFamily:"YekanBakh !important", color:"#fff !important"}} onClick={handleClose}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <MenuItem onClick={handleLogout} sx={{ fontFamily:"YekanBakh !important" , m: 1 , color:"#fff"}}>
          خروج
        </MenuItem>
      </MenuPopover>
    </>
  );
}
